/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { Caret } from '../../common';
import { RootState } from '../../../store/root.reducers';
import { InteractiveComponents } from '../../../core/enums/InteractiveComponents';

import './InteractiveLayer.scss';

const InteractiveLayer: FunctionComponent = (): JSX.Element => {
    const activeComponent = useSelector(
        (state: RootState) => state.interactiveLayer.activeComponent,
    );
    const isCaretVisible = useSelector((state: RootState) => state.gridGuide.isCaretVisible);

    return (
        <React.Fragment>
            <Caret
                direction={InteractiveComponents.EAST}
                visible={isCaretVisible && activeComponent === InteractiveComponents.EAST}
                active={activeComponent === InteractiveComponents.EAST}
                className="guide-east"
            />

            <Caret
                direction={InteractiveComponents.WEST}
                visible={isCaretVisible && activeComponent === InteractiveComponents.WEST}
                active={activeComponent === InteractiveComponents.WEST}
                className="guide-west"
            />

            <Caret
                direction={InteractiveComponents.NORTH}
                visible={isCaretVisible && activeComponent === InteractiveComponents.NORTH}
                active={activeComponent === InteractiveComponents.NORTH}
                className="guide-north"
            />

            <Caret
                direction={InteractiveComponents.SOUTH}
                visible={isCaretVisible && activeComponent === InteractiveComponents.SOUTH}
                active={activeComponent === InteractiveComponents.SOUTH}
                className="guide-south"
            />
        </React.Fragment>
    );
};

export default InteractiveLayer;
